import {IWD} from './_Models'

export const DefaultWD: IWD = {
  id: false,
  host: '',
  name: '',
  directions: [],
  description: '',
  links: null,
  mainColor: '#ff0000',
  logoUrl: '',
  logoDarkUrl: '',
  faviconUrl: '',
  logoPrep: '',
  authParams: {},
  gtmId: '',
}
